module.exports = __webpack_public_path__ + "463127a04059fd449d78dcf5bafaaed6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/preview.png
// module id = 1041
// module chunks = 0